import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import DemoCompanyGate from './DemoCompanyGate'
import CreateDemoCompany from './DemoCustomer/DemoCustomer'
import EditDemoCompany from './pages/EditDemoCompany/EditDemoCompany'
import ListDemoCompany from './pages/ListDemoCompany/ListDemoCompany'
import ViewDemoCompany from './ViewDemoCustomer/ViewDemoCustomer'
import { DEMO_COMPANY_MANAGEMENT } from './paths'

const DemoCompanyManagementRoutes = {
  path: DEMO_COMPANY_MANAGEMENT,
  component: DemoCompanyGate,
  onEnter(
    _nextState: unknown,
    _replace: unknown,
    callback: (err?: { status: number; message: string }) => void
  ) {
    // The whole section, including every child route, is platform-admin only.
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: ListDemoCompany,
  },
  childRoutes: [
    {
      path: 'create',
      component: CreateDemoCompany,
    },
    {
      path: ':id/view',
      component: ViewDemoCompany,
    },
    {
      path: ':id/edit',
      component: EditDemoCompany,
    },
  ],
}

export default DemoCompanyManagementRoutes
